import { render, staticRenderFns } from "./GroupFormModal.vue?vue&type=template&id=daa8919a"
import script from "./GroupFormModal.vue?vue&type=script&lang=js"
export * from "./GroupFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports